import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'

/**
 * The outlined `EntityActionButton` treatment (Edit Team) as a square icon-only
 * button: same 8px radius, PRIMARY border, transparent fill and opacity hover,
 * sized to match that button's height so the cluster stays on one baseline.
 * Shared by the header's roster and organization import/export triggers.
 */
export const panelIconButtonStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border-radius: 8px;
  background-color: transparent;
  color: ${colors.NEUTRAL_0};
  border: 1px solid ${colors.PRIMARY};
  cursor: pointer;
  transition: opacity 0.15s ease;

  .anticon {
    font-size: 16px;
  }

  &:hover:not(:disabled) {
    opacity: 0.85;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 2px solid ${colors.PRIMARY};
    outline-offset: 2px;
  }
`

/** Two 34px skeleton squares standing in for a pair of icon buttons. */
export const panelIconSkeletonStyle = css`
  display: flex;
  align-items: center;
  gap: 8px;
`
